import { InterceptService } from './../../../../../../../core/intercept/intercept.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCHeaderPixModule } from '@wlp/ui-c-header-pix';
import { UiCSwiperModule } from '@wlp/ui-c-swiper';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PixRegisterKeyPageRoutingModule } from './register-key-pix-routing.module';

import { PixRegisterKeyPage } from './register-key-pix.page';
import { UiCPixConsentUseModule } from '@wlp/ui-c-pix-consent-use'

import { BrMaskerModule } from 'br-mask';

import { UiCPixRegisterKeyModule } from '@wlp/ui-c-pix-registrer-key'
import { UiBsPixModule } from '@wlp/ui-bs-pix';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UiBsMyDataModule } from '@wlp/ui-bs-my-data';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PixRegisterKeyPageRoutingModule,
    UiBsTranslateModule,
    UiCHeaderPixModule,
    UiCSwiperModule,
    UiCButtonModule,
    AngularSvgIconModule,
    UiCPixConsentUseModule,
    BrMaskerModule,
    UiCPixRegisterKeyModule,
    UiBsPixModule,
    UiBsMyDataModule,
    HeaderUserInfoModule,
  ],
  declarations: [PixRegisterKeyPage],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ]
})
export class PixRegisterKeyModule { }

